// Copyright (c) 2022 Deere & Company

import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateClosingAccountChangesLength = (state, action) => action.length;

export default (state = getWipDefaultState().closingAccountLength, action) => {

    const actionTypes = {
        [actions.UPDATE_TCSM_CLOSING_ACCOUNT_LENGTH]: updateClosingAccountChangesLength
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tcsm/wip/reducers/closing-account-length.js